import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuthStore } from "../../store/useAuthStore";
import {
  useGetUserCompanyDetails,
  useGetUserRoleAndPermission,
  useSwitchCompany,
} from "../../queries";
import { usePermissionStore } from "../../store";
import { Permission } from "../../types/UserDetailModel";

function HandleHissaRedirect() {
  const { setAuth, accessToken } = useAuthStore();
  const { data, refetch: getPermission } = useGetUserRoleAndPermission();
  const { setPermission } = usePermissionStore();
  const { mutate: switchUserCompany } = useSwitchCompany();
  const { data: currentCompanyDetails, refetch: refetchUserCompanyDetails } =
    useGetUserCompanyDetails();
  const [companySwitched, setCompanySwitched] = useState(false);
  const [companyId, setCompanyId] = useState("");

  useEffect(() => {
    if (!companySwitched && accessToken && companyId) {
      const switchCompanyObject = {
        companyId,
      };
      switchUserCompany(switchCompanyObject, {
        onSuccess: (data) => {
          getPermission().then((permission) => {
            if (permission !== undefined && permission.data !== undefined)
              setPermission(permission.data);
          });
          refetchUserCompanyDetails();
          setCompanySwitched(true);
          const currentURL = window.location.href;

          const urlObj = new URL(currentURL);
          const domain = urlObj.origin; // Get the domain
          const path = urlObj.pathname; // Get the path

          const newURL = domain + path;

          // eslint-disable-next-line no-restricted-globals
          history.replaceState(null, "", newURL);
        },
        onError: (error) => {
          toast("Error logging in to company", {
            type: "error",
            autoClose: 2000,
          });
        },
      });
    }
  }, [accessToken, companyId]);

  useEffect(() => {
    const params = window.location.search;
    if (params) {
      const urlSearchParams = new URLSearchParams(params);
      const accesstoken = urlSearchParams.get("logintoken");
      const xUsrToken = urlSearchParams.get("x-usr-token");
      const companyId = urlSearchParams.get("companyId");
      const redirectUri = urlSearchParams.get("redirectURL");
      if (xUsrToken) {
        sessionStorage.setItem("currentUser", xUsrToken);
      }
      if (accesstoken) {
        setAuth({ isAuthenticated: true, accessToken: accesstoken });
      }
      if (redirectUri) {
        sessionStorage.setItem("hissaUrl", redirectUri);
      }
      if (companyId) {
        sessionStorage.setItem("companyId", companyId);
        setCompanyId(companyId);
      }
    }
  }, []);
  return null;
}

export default HandleHissaRedirect;
